export const PRINT_TYPE = {
    POS:0,
    DOT_MATRIX:1,
    SMS:2,
    }